import Box from '@mui/material/Box';
import { StyledCheckbox } from 'v3/shared/components/Checkbox';
import { BodySmallBold, BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { theme } from 'v3/styles/global-styles';
import { Container } from './styles';
import { ItemType } from './types';

export const Item = ({ store, onClick }: ItemType) => {
  const handleOnClick = () => {
    const updatedStore = { ...store, checked: !store.checked };
    onClick(updatedStore);
  };

  return (
    <Container onClick={handleOnClick}>
      <StyledCheckbox
        key={store.id}
        size="medium"
        value={store.checked}
        checked={store.checked ? store.checked : false}
        defaultChecked={store.checked}
      />

      <Box>
        <BodySmallBold color={theme.palette.common.white}>{store.name}</BodySmallBold>
        {store.address?.street ? (
          <BodySmallRegular color={theme.palette.common.white}>
            {store.address.street}, {store.address.number} - {store.address.city} - {store.address.state} - cnpj:{' '}
            {store.cnpj}
          </BodySmallRegular>
        ) : null}
      </Box>
    </Container>
  );
};
